module.exports = __webpack_public_path__ + "img/khqy.bc1589a2.png";